"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.waitForHash = exports.createPendingLogs = exports.sendTransaction = exports.sentTx = void 0;
var exponential_backoff_1 = require("exponential-backoff");
var types_1 = require("@rarible/types");
var address_1 = require("@rarible/types/build/address");
function sentTx(source, options) {
    return __awaiter(this, void 0, void 0, function () {
        var event;
        return __generator(this, function (_a) {
            event = source.send(__assign(__assign({}, options), { gas: 3000000 }));
            return [2 /*return*/, waitForHash(event)];
        });
    });
}
exports.sentTx = sentTx;
function sendTransaction(notify, source, options) {
    return __awaiter(this, void 0, void 0, function () {
        var event, hash;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event = source.send(options);
                    return [4 /*yield*/, waitForHash(event)];
                case 1:
                    hash = _a.sent();
                    return [4 /*yield*/, notify(hash)];
                case 2:
                    _a.sent();
                    return [2 /*return*/, hash];
            }
        });
    });
}
exports.sendTransaction = sendTransaction;
function createPendingLogs(api, web3, hash) {
    return __awaiter(this, void 0, void 0, function () {
        var tx, createTransactionRequest;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getTransaction(web3, hash)];
                case 1:
                    tx = _a.sent();
                    createTransactionRequest = __assign(__assign({}, tx), { hash: types_1.toWord(hash), from: address_1.toAddress(tx.from), to: tx.to ? address_1.toAddress(tx.to) : undefined, input: types_1.toBinary(tx.input) });
                    return [2 /*return*/, api.createGatewayPendingTransactions({ createTransactionRequest: createTransactionRequest })];
            }
        });
    });
}
exports.createPendingLogs = createPendingLogs;
function getTransaction(web3, hash) {
    return exponential_backoff_1.backOff(function () { return web3.eth.getTransaction(hash); }, { maxDelay: 5000, numOfAttempts: 10, delayFirstAttempt: true, startingDelay: 300 });
}
function waitForHash(promiEvent) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise((function (resolve, reject) {
                    promiEvent.on("transactionHash", function (hash) { return resolve(hash); });
                    promiEvent.on("error", function (error) { return reject(error); });
                }))];
        });
    });
}
exports.waitForHash = waitForHash;
